import base from "./base.service";

const authorizedInstance = base.service(true);
const unauthorizedInstance = base.service(false);

export const createPlayroom = (playroom) => {
  return authorizedInstance.post(`/Playroom/create-new`, playroom);
};
export const updatePlayroom = (playroomId, playroom) => {
  return authorizedInstance.post(`/Playroom/update/${playroomId}`, playroom);
};
export const getAllPlayrooms = (pageSize, pageNumber) => {
  let query = `/Playroom/get-all?PageSize=${pageSize}&PageNumber=${pageNumber}`;

  return unauthorizedInstance.get(query);
};
export const getById = (id) => {
  console.log(`call:/Playroom/by-id/${id}`);

  return unauthorizedInstance.get(`/Playroom/by-id/${id}`);
};
export const addPackage = (packageData) => {
  return authorizedInstance.post(`/Playroom/add-package`, packageData);
};
export const deletePackageById = (packageId) => {
  return authorizedInstance.delete(`/Playroom/delete-package/${packageId}`);
};
export const addSpecialOffer = (specialOfferData) => {
  return authorizedInstance.post(
    `/Playroom/create-special-offer`,
    specialOfferData
  );
};
export const uploadImage = async (id, files) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file.originFileObj);
  });

  return authorizedInstance.post(`/Playroom/upload/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const changePlayroomStatus = (playroomId) => {
  return authorizedInstance.post(`/Playroom/change-status/${playroomId}`);
};

export const changePremiumPlayroomStatus = (playroomId) => {
  return authorizedInstance.post(`/Playroom/update-premium/${playroomId}`);
}

const playroomService = {
  getAllPlayrooms,
  updatePlayroom,
  getById,
  addPackage,
  addSpecialOffer,
  createPlayroom,
  uploadImage,
  changePlayroomStatus,
  deletePackageById,
  changePremiumPlayroomStatus
};

export default playroomService;
